export const enUSDashboard = {
  welcome: 'Welcome, {{name}}',
  welcomeFallbackName: 'User',
  upcomingBillsHeading: 'Upcoming Bills',
  upcomingBillsLoading: 'Loading bills...',
  upcomingBillsError: 'Failed to load bills',
  due3Days: 'Due in 3 Days',
  overdue30Plus: 'Overdue 30+ days',
  overdue8to30: 'Overdue 8–29 days',
  overdue1to7: 'Overdue 1–7 days',
  relOverdue: '{{days}}d overdue',
  relToday: 'Due today',
  relInDays: 'In {{days}}d',
  noBills3Days: 'No bills due in the next 3 days',
  billDueLabel: 'Due: ',
  trendsHeading: 'Spending Trends',
  trendsLoading: 'Loading trends...',
  trendsNoData: 'No spending data available',
  trendsTotal: 'Total: ',
  trendsSpending: 'Spending',
  trendsPaid: 'Paid',
  trendsUnpaid: 'Unpaid',
  categoryHeading: 'Spending by Category - {{month}}',
  categoryLoading: 'Loading breakdown...',
  categoryNoData: 'No spending data for this month',
  categoryTotalSpent: 'Total Spent',
  incomeVsExpensesHeading: 'Income vs Expenses',
  incomeVsExpensesLoading: 'Loading income data...',
  incomeVsExpensesIncome: 'Income',
  incomeVsExpensesExpenses: 'Expenses',
  markBillPaid: 'Mark as paid',
  statMonthTotal: 'Month total',
  statPaid: 'Paid',
  statPending: 'Pending',
  statOverdueHint: 'Includes expenses that are already due and unpaid',
  kpiOverdue: 'Overdue',
  kpiDueSoon: 'Due soon (3 days)',
  kpiBillsCount_one: '{{count}} bill',
  kpiBillsCount_other: '{{count}} bills',
} as const;
